import React, { useEffect } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, FolderTree, ShoppingBag, Users, Tag, Image, Settings as SettingsIcon, LogOut, Store } from "lucide-react";
import Logo from "@/components/Logo";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/produtos", label: "Produtos", icon: Package },
  { to: "/admin/categorias", label: "Categorias", icon: FolderTree },
  { to: "/admin/pedidos", label: "Pedidos", icon: ShoppingBag },
  { to: "/admin/clientes", label: "Clientes", icon: Users },
  { to: "/admin/cupons", label: "Cupons", icon: Tag },
  { to: "/admin/conteudo", label: "Conteúdo", icon: Image },
  { to: "/admin/configuracoes", label: "Configurações", icon: SettingsIcon },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/admin/login");
  }, [user, loading, nav]);

  if (!user || user.role !== "admin") return null;

  return (
    <div className="min-h-screen bg-[#FFF9FA] flex">
      <aside className="hidden md:flex flex-col w-64 bg-[#4A3B40] text-[#F9E1E8] p-5 fixed left-0 top-0 bottom-0 overflow-y-auto">
        <div className="mb-8"><Logo variant="dark" /></div>
        <nav className="flex-1 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({isActive}) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? 'bg-[#E8A0B4] text-white font-semibold' : 'hover:bg-white/10'}`}
              data-testid={`admin-nav-${it.label.toLowerCase()}`}
            >
              <it.icon className="w-4 h-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="pt-4 mt-4 border-t border-white/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-[#F9E1E8]/80 hover:text-white"><Store className="w-4 h-4" /> Ver loja</Link>
          <button onClick={()=>{logout(); nav("/admin/login");}} className="flex items-center gap-2 text-xs text-[#F9E1E8]/80 hover:text-white" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Sair</button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-[#4A3B40] text-white z-30 px-4 py-3 flex items-center justify-between">
        <Logo size="sm" variant="dark" />
        <select onChange={(e)=>nav(e.target.value)} className="bg-white/10 text-white text-sm rounded-full px-3 py-1 border-none outline-none">
          {items.map(it => <option key={it.to} value={it.to}>{it.label}</option>)}
        </select>
      </div>

      <main className="flex-1 md:ml-64 p-4 md:p-8 pt-16 md:pt-8">
        <Outlet />
      </main>
    </div>
  );
}
